import { render, staticRenderFns } from "./BizBusinessinfoBusinessTypeForm.vue?vue&type=template&id=2aef9be2&"
import script from "./BizBusinessinfoBusinessTypeForm.vue?vue&type=script&lang=js&"
export * from "./BizBusinessinfoBusinessTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports